import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h1", null, [
      _createElementVNode("a", {
        href: "",
        class: "icon_wrap"
      }, [
        _createElementVNode("img", {
          src: "img/logo.png",
          alt: "디지털 성매매 시민참여 플랫폼 관리자"
        })
      ])
    ], -1)
  ]))]))
}